module.exports = __webpack_public_path__ + "img/icon-arrow-left.ebd25fa9.svg";